import { MANAGE_ACCOUNTS } from '../actionTypes';

const initialState = {
  content: [],
  selectedAccountDetails: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MANAGE_ACCOUNTS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case MANAGE_ACCOUNTS.SUCCESS_BY_ID:
      return {
        ...state,
        selectedAccountDetails: action.payload,
      };
    default:
      return state;
  }
};
